module.exports = __webpack_public_path__ + "static/media/Left AP Z1.597b45fc.png";